import { useEffect, useState } from "react";
import { fetchEventData } from "../Api/ViewEvent";
import { Container, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
//import "../Styling/ViewEvent.css";

const ViewEvent = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const data = await fetchEventData();
        console.log("Fetched Events:", data);
        
        if (Array.isArray(data)) {
          setEvents(data);
        } else if (data.data && Array.isArray(data.data)) {
          setEvents(data.data);
        } else {
          console.error("Unexpected Data Format:", data);
          toast.error("Invalid event data format");
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        toast.error("🦄 Error Fetching Events");
      }
    };
  
    loadEvents();
  }, []);

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">View Events</span>

          {events.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      {Object.keys(events[0]).map((key) => (
                        <th key={key}>{key.replace(/([A-Z])/g, " $1").trim()}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((event, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        {Object.values(event).map((value, i) => (
                          <td key={i}>
                            {typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/) 
                              ? new Date(value).toLocaleDateString() 
                              : value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No events found.</p>
          )}
        </Container>
      </div>
  );
};

export default ViewEvent;